import React from 'react';
import LiveRoomList from '../components/LiveRoomList';
import { useNavigate } from 'react-router-dom';

export default function LiveRoomsDiscoveryPage() {
    const navigate = useNavigate();
    return (
        <div className="container" style={{ paddingTop: '100px', minHeight: '100vh' }}>
            <LiveRoomList onJoinRoom={(roomId) => navigate(`/live/${roomId}`)} />
        </div>
    );
}
